module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AX - Aland Islands.d4d9ecc4.svg";